import React from 'react';
import { 
  Box, 
  Typography, 
  Paper,
  Grid
} from '@mui/material';
import QRCode from 'react-qr-code';

/**
 * Displays session instructions and registration QR code
 * 
 * @param {Object} props
 * @param {Object} props.currentSession - Currently active session
 * @param {string|number} props.venueId - The venue ID to be used in registration link
 */
const InstructionsPanel = ({ currentSession, venueId }) => {
  const [urlRegister, setUrlRegister] = React.useState('');

  React.useEffect(() => {
    setUrlRegister(`${window.location.origin}/register?venue_id=${venueId}`);
  }, [venueId]);

  return (
    <Paper elevation={3} sx={{ p: 4, mb: 4}}>
      <Typography variant="h3" gutterBottom align='center' sx={{ fontSize: '2.8rem', mb: 3 }}>
        Enkele belangrijke richtlijnen
      </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1" paragraph fontSize="1.8rem" sx={{ mb: 2.5 }}>
              Registreer je transponder voor deze sessie via onderstaande QR-code of volgende link: <strong>{urlRegister}</strong>
            </Typography>
            <Typography component="li" variant="body1" paragraph fontSize="1.8rem" sx={{ mb: 2.5 }}>
              Volg de aanwijzingen van de begeleider tijdens de hele sessie.
            </Typography>
            <Typography component="li" variant="body1" paragraph fontSize="1.8rem" sx={{ mb: 2.5 }}>
              Respecteer de andere deelnemers en houd voldoende afstand.
            </Typography>
          </Box>


          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mt: 6
          }}>
            <Typography variant="h4" gutterBottom align='center' sx={{ fontSize: '2.2rem', mb: 3 }}>
              Registratie
            </Typography>

            {currentSession && (
              <QRCode 
                value={urlRegister}
                size={320}
              />
            )}
          </Box>


    </Paper>
  );
};

export default InstructionsPanel;